<template>
  <section class="range-constructor">
    <readonly-alert v-if="!authorized" />
    <saved-scenario-alert
      v-if="savedScenario"
      v-bind:title="savedScenario.title"
    />
    <header class="page-header">
      <h1>Range constructor</h1>
    </header>
    <section class="grid-container">
      <grid-selector
        v-bind:generalHands="state.generalHands"
        v-bind:rangeConstructor="true"
        v-bind:specificHandsNotAllowed="true"
        v-on:selectGeneralHand="selectGeneralHand($event.generalHandString)"
        v-on:deselectGeneralHand="deselectGeneralHand($event)"
        v-on:selectGeneralHands="selectGeneralHands($event)"
        v-on:deselectGeneralHands="deselectGeneralHands($event)"
      />
      <button
        class="btn btn-default btn-block"
        v-bind:disabled="!authorized"
        v-on:click="$store.commit('rangeConstructor/deselectAllGeneralHands')"
      >
        Reset
      </button>
      <create-sharable-url-button
        v-bind:disabled="!authorized"
        v-on:createSharableUrl="$emit('createSharableUrl', {
          method: 'createSharableRangeConstructorURL',
          state: state,
        })"
      ></create-sharable-url-button>
      <save-scenario-button
        v-bind:savedScenario="savedScenario"
        v-bind:disabled="!authorized"
        v-on:saveScenario="$emit('saveScenario', {
          method: 'createSharableRangeConstructorURL',
          savedScenarioPropertyName: 'rangeConstructor',
          state: state,
        })"
        v-on:updateScenario="$emit('updateScenario', {
          method: '_constructRangeConstructorData',
          state: state,
        })"
      ></save-scenario-button>
    </section>
    <action-selector
      v-bind:actions="actionsWithIds"
      v-bind:indexOfSelectedAction="state.indexOfSelectedAction"
      v-bind:authorized="authorized"
      v-on:selectAction="$store.commit('rangeConstructor/selectAction', $event)"
      v-on:setNameOfAction="$store.commit('rangeConstructor/setNameOfAction', $event)"
      v-on:addAction="$store.commit('rangeConstructor/addAction')"
      v-on:removeAction="$store.commit('rangeConstructor/removeAction', $event)"
      v-on:applyToAllUnselectedHands="$store.commit('rangeConstructor/applyToAllUnselectedHands', $event)"
    />
    <onboarding-modal
      toolName="range constructor"
      urlPath="range-constructor"
    />
    <help-icon path="/help/range-constructor" />
  </section>
</template>

<script>
import ReadonlyAlert from '@/components/utilities/readonly-alert';
import SavedScenarioAlert from '@/components/utilities/saved-scenario-alert';
import GridSelector from '@/components/hand-range/grid-selector/grid-selector';
import ActionSelector from '@/components/range-constructor/action-selector';
import SharableUrlModal from '@/components/sharable-url-modal';
import shareUrlService from '@/services/share-url-service';
import SaveScenarioModal from '@/components/save-scenario-modal';
import OnboardingModal from '@/components/onboarding-modal';
import CreateSharableUrlButton from '@/components/controls/create-sharable-url-button';
import SaveScenarioButton from '@/components/controls/save-scenario-button';
import HelpIcon from '@/components/help-icon';
import _ from 'lodash';

export default {
  name: 'range-constructor',
  components: {
    'readonly-alert': ReadonlyAlert,
    'saved-scenario-alert': SavedScenarioAlert,
    'grid-selector': GridSelector,
    'action-selector': ActionSelector,
    'create-sharable-url-button': CreateSharableUrlButton,
    'save-scenario-button': SaveScenarioButton,
    'onboarding-modal': OnboardingModal,
    'help-icon': HelpIcon,
  },
  computed: {
    state: function () {
      return this.$store.state.rangeConstructor;
    },
    savedScenario: function () {
      let routeId = this.$route.params.id;

      if (!this.authorized) {
        return false;
      }

      return this.$store.state.account.user.savedScenarios.rangeConstructor.find(function (savedScenario) {
        return savedScenario.url.includes(routeId);
      });
    },
    actionsWithIds: function () {
      return this.state.actions.map(function (action) {
        action.id = _.uniqueId();

        return action
      });
    },
    authorized: function () {
      return this.$store.getters['account/authorizedForPremium'];
    },
  },
  mounted: function () {
    if (this.$route.params.id) {
      this.load();
    }

    this.handleOnboard();
  },
  methods: {
    // mounted
    load: function () {
      let self = this;

      self.$http.get(`${process.env.BASE_API_URL}/sharable-url-store/` + self.$route.params.id)
        .then(function (response) {
          if (!response || !response.data.storeState) {
            alert('Didn\'t get data back from server. Redirecting to the default range constructor page.');
            self.$router.push('/range-constructor');
          } else {
            self.$store.commit('rangeConstructor/setState', response.data.storeState);
          }
        })
        .catch(function () {
          alert('URL doesn\'t exist. Redirecting to the default range constructor page.');
          self.$router.push('/range-constructor');
        })
      ;
    },
    handleOnboard: function () {
      let self = this;

      if (
        !self.authorized ||
        !self.$store.state.account.user.settings.onboarding ||
        self.$store.state.account.user.settings.onboarding.rangeConstructor
      ) {
        return;
      }

      $(self.$el).find('.onboarding-modal').modal();
      self.$http
        .patch(`${process.env.BASE_API_URL}/user/onboard`, { page: 'rangeConstructor' })
        .then(function () {
          self.$store.commit('account/onboard', 'rangeConstructor');
        })
        .catch(function () {
          console.log('Error: Unable to onboard.');
        })
      ;
    },
    selectGeneralHand: function (generalHandString) {
      if (!this.authorized) {
        return;
      }

      this.$store.commit('rangeConstructor/selectGeneralHand', generalHandString);
    },
    deselectGeneralHand: function (generalHandString) {
      if (!this.authorized) {
        return;
      }

      this.$store.commit('rangeConstructor/deselectGeneralHand', generalHandString);
    },
    selectGeneralHands: function (generalHandStrings) {
      if (!this.authorized) {
        return;
      }

      this.$store.commit('rangeConstructor/selectGeneralHands', generalHandStrings);
    },
    deselectGeneralHands: function (generalHandStrings) {
      if (!this.authorized) {
        return;
      }

      this.$store.commit('rangeConstructor/deselectGeneralHands', generalHandStrings);
    },
  },
};

</script>

<style lang="scss" scoped>
  .grid-container {
    display: inline-block;
    width: 443px;

    button, .create-sharable-url-button-container, .save-scenario-button-container {
      margin: 10px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/range-constructor/range-constructor.vue